import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=be1a5a4a&scoped=true"
import script from "./TagIcon.vue?vue&type=script&lang=js"
export * from "./TagIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a5a4a",
  null
  
)

export default component.exports